export default "__VITE_ASSET__CFyS0H4N__"